import { keys, not, pick } from "ramda"
import { isNilOrEmpty } from "ramda-extension/es"
import { call, put, select, takeEvery, takeLatest } from "redux-saga/effects"

import { NotificationsV1 } from "@cirrus/common/Notifications/v1"
import { Actions, Atom, Data, Namespace } from "@cirrus/fe-lib"

import { L10n } from "../../../features/index.js"
import { CirrusApi } from "../../../shared/index.js"
import { Customer } from "../../customer/index.js"
import { Notifications } from "../../notifications/index.js"
import { Skins } from "../_params.js"

export const domain = Namespace.domain(Skins, "data")

const defaultState = {
  marionetteSkinLink: null,
  reactSkin: {},
}

export const actions = Actions.of(domain, [
  "dataRequested",
  "dataObtained",
  "dataFetchCancelled",
  "dataFetchFailed",
])

export const atom = Atom.behavior((on) => {
  on(actions.dataObtained, (state, payload) =>
    Data.merged(state, pick(keys(defaultState), payload)),
  )
}, defaultState)

const { showNotificationOn } = NotificationsV1.sagas

export const effects = [
  takeLatest(Customer.actions.infoFetched, function* () {
    yield put(actions.dataRequested())
  }),

  takeLatest(actions.dataRequested, function* () {
    const { skinId } = yield select(Customer.state.info)

    if (not(isNilOrEmpty(skinId))) {
      try {
        const { data } = yield call(CirrusApi.skins.skinGet, skinId)

        yield put(actions.dataObtained(Data.merged({}, pick(["skinObject"], App), data)))
      } catch (error) {
        yield put(actions.dataFetchFailed({ error }))
      }
    } else {
      yield put(actions.dataFetchCancelled())
    }
  }),

  takeEvery(actions.dataFetchFailed, function* ({ payload: { error } }) {
    console.error(error)
  }),

  showNotificationOn(actions.dataFetchFailed, () => ({
    message: L10n.lib.string("Notification.Messages.Skins:DataFetchFailed"),
    type: Notifications.params.types.error,
  })),
]
